import type { RiskThresholdRequest } from '../../request/api/risk';

/** 风控阈值设置表单的默认值。 */
export const defaultFormValue: RiskThresholdRequest = {
    // 是否启用餐厅整体风控能力，默认开启
    risk_control_enabled: true,

    // 是否开启堂食最大优惠限制
    dine_in_max_discount_enabled: true,
    // 堂食最大优惠限制的模式（金额 / 百分比）
    dine_in_max_discount_mode: 'BOTH',
    // 堂食最大优惠金额（按 AMOUNT 模式）
    dine_in_max_discount_amount: 20,
    // 堂食最大优惠折扣百分比（按 PERCENT 模式）
    dine_in_max_discount_percent: 20,
    // 堂食最大优惠触发逻辑（与金额、比例等条件组合方式）
    dine_in_max_discount_trigger_logic: 'OR',

    // 堂食单笔订单允许的最大退菜数量
    dine_in_max_refund_item_count: 5,
    // 堂食单笔订单允许的最大退菜金额
    dine_in_max_refund_amount: 10,
    // 堂食判定“点菜数量异常”的菜品数量阈值
    dine_in_abnormal_item_count_threshold: 20,
    // 堂食最大用餐时长（分钟）
    dine_in_max_dining_duration_minutes: 120,
    // 堂食-订单关闭检测：窗口内订单数 / 窗口时长（分钟，接口 dine_in_order_close_interval_minutes）
    dine_in_order_close_check_window_number: 1,
    dine_in_order_close_interval_minutes: 2,

    // 是否开启外卖最大优惠限制
    delivery_max_discount_enabled: true,
    // 外卖最大优惠限制的模式（金额 / 百分比）
    delivery_max_discount_mode: 'BOTH',
    // 外卖最大优惠金额（按 AMOUNT 模式）
    delivery_max_discount_amount: 20,
    // 外卖最大优惠折扣百分比（按 PERCENT 模式）
    delivery_max_discount_percent: 20,
    // 外卖最大优惠触发逻辑（与金额、比例等条件组合方式）
    delivery_max_discount_trigger_logic: 'OR',
    // 外卖-订单关闭检测：窗口内订单数 / 窗口时长（秒，接口 delivery_order_close_check_window_seconds）
    delivery_order_close_check_window_number: 10,
    delivery_order_close_check_window_seconds: 60,

    // 取消订单风险提示开关
    cancel_order_risk_alert_enabled: false,

    // 是否通过 WhatsApp 接收营业分析总结报告
    shift_briefing_whatsapp_enabled: false,
    // 是否开启 WhatsApp 风控通知
    risk_notify_whatsapp_enabled: false,
    // 接收风控通知的 WhatsApp 号码
    risk_notify_whatsapp_receiver: '',
    // WhatsApp 号码国家区号
    risk_notify_whatsapp_prefix: '39',
    // 是否开启 Email 风控通知
    risk_notify_email_enabled: false,
    // 接收风控通知的 Email 地址
    risk_notify_email_receiver: '',
    // Email 风控通知发送模式（DAILY 每日汇总 / REALTIME 实时推送）
    risk_notify_email_send_mode: 'REALTIME',
};

/**
 * 判断是否因开启任一 WhatsApp 推送而必须填写接收号码。
 * @param formValue - 包含两个 WhatsApp 推送开关的表单值
 * @returns 任一 WhatsApp 推送开关开启时返回 true
 */
export function isWhatsAppReceiverRequired(
    formValue: Pick<
        RiskThresholdRequest,
        'shift_briefing_whatsapp_enabled' | 'risk_notify_whatsapp_enabled'
    >,
): boolean {
    return Boolean(
        formValue.shift_briefing_whatsapp_enabled || formValue.risk_notify_whatsapp_enabled,
    );
}
